module.exports = __webpack_public_path__ + "media/images/help/flow/pill-10days-17ff88ae2cb5711b8b9270cd2c2be5c1.svg";